<template>
	<b-overlay :show="count > 0"
			   z-index="10000"
			   class="loading"
			   no-wrap>
	</b-overlay>
</template>

<script>
    export default {
		name: 'Loading',
		watch: {
			count: {
				immediate: true,
				handler(newValue, oldValue) {
					var $this = this
					
					if (newValue > 0) {
						this.$store.dispatch(
							"Timeouts/set",
							{
								name: "Loading",
								callback: function () { $this.$store.commit("Loading/cancel") },
								timeout: 5000
							})

					}
					else if(newValue < 1) {
						$this.$store.commit("Loading/cancel")
					}
				}
			}
		},
		destroyed: function () {
			this.$store.commit("Timeouts/clear", "Loading")
		},
        computed: {
			count: function () { return this.$store.state.Loading.count }
        }
    }
</script>

<style scoped>
	.loading {
		position: fixed !important;
		z-index: 10000000;
	}
</style>